module.exports = __webpack_public_path__ + "static/media/zoom-open.6a9133e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/zoom-open.svg
// module id = 2409
// module chunks = 0